import { fetchOrganization } from './../../features/organization/organizationSlice';
import { PUBLIC_DEFAULT_ROUTE } from '../../constants/common';
import { Navigate } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const AdminLayout = ({ children }) => {
  const { user, userOrganizationId } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchOrganization(userOrganizationId));
  }, []);

  if (!user) {
    return <Navigate to={PUBLIC_DEFAULT_ROUTE} />;
  }

  return <>{children}</>;
};

export default AdminLayout;
